import { connect } from 'react-redux';
import PopupQRCode from './PopupQRCode';
import {
  qrData,
  qrDataClear,
  qrDataUpdateStorage,
  qrDataList
} from '../../store/actions/qr';

const mapStateToProps = ({ qrReducer, stockReducer }) => ({ qrReducer, stockReducer });
const mapDispatchToProps = {
  qrData,
  qrDataClear,
  qrDataUpdateStorage,
  qrDataList
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopupQRCode);
